/* eslint-disable prettier/prettier */
export const UserTableHeader = ({ isSuperAdmin }: { isSuperAdmin: boolean }) => {
  return isSuperAdmin ? (
    <div className="flex items-center px-4 py-3 font-semibold border text-md sm:w-[90%] bg-gray-50 text-muted-foreground">
      <div className="w-[30%] sm:ml-12">User</div>
      <div className="w-[25%] sm:ml-[-48px]">Company</div>
      <div className="w-[20%]">Role</div>
      <div className="w-[20%]">Status</div>
      <div className="w-[5%] text-right"></div>
    </div>
  ) : (
    <div className="flex items-center px-4 py-3 font-semibold border text-md sm:w-[90%] bg-gray-50 text-muted-foreground">
      <div className="w-[40%] sm:ml-12">User</div>
      <div className="w-[30%] sm:ml-[-48px]">Role</div>
      <div className="w-[30%]">Status</div>
      <div className="w-[5%] text-right"></div>
    </div>
  );
};
